module.exports = __webpack_public_path__ + "img/pdf.b4fba180.png";